// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'circle-stacked-solid';

export const Component = () => (
  <path d='M17.666 8.136c0 .096 0 .239.048.383v.335c0 2.442-.862 4.501-2.586 6.226-1.772 1.772-3.831 2.634-6.274 2.634-.048 0-.191 0-.335-.048h-.383c.479 1.868 1.484 3.353 3.065 4.454 1.533 1.102 3.257 1.58 5.172 1.437 1.916-.144 3.544-.91 4.933-2.3 1.34-1.34 2.107-2.969 2.251-4.884.144-1.916-.335-3.64-1.437-5.22-1.101-1.533-2.586-2.539-4.454-3.018ZM14.41 3.299c1.533 1.533 2.3 3.4 2.3 5.556 0 2.155-.767 4.022-2.3 5.555-1.533 1.533-3.4 2.3-5.555 2.3-2.156 0-4.023-.767-5.556-2.3C1.766 12.877 1 11.01 1 8.855c0-2.156.766-4.023 2.3-5.556C4.831 1.766 6.7 1 8.854 1c2.154 0 4.022.766 5.555 2.3Z' />
);

export const viewBox = '0 0 25 25';
